exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graph-data-box[data-v-46c39325] {\n  height: 450px !important;\n  animation: fadeIn 0.3s ease-in-out forwards;\n}\n.graph-header[data-v-46c39325] {\n  /* display: flex;\n        justify-content: space-between; */\n}\n.graph-header .table-heading[data-v-46c39325] {\n    font-size: 14px;\n    padding: 15px;\n    font-weight: 700;\n    color: #ffffff;\n    background: #172b43;\n    text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-46c39325","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/GraphCard.vue
// module id = 568
// module chunks = 0